import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { Loader } from '../../../../../common/components';
const ListPage = loadable(() => import('./ListPage'), {
  fallback: <Loader />
});
const OwnRoutes = ({ t, updateSelectedTab, alert }) => {
  return [
    <Route
      key="own_record_list"
      exact
      path="/own"
      element={<ListPage t={t} updateSelectedTab={updateSelectedTab} alert={alert} />}
    />
  ];
};
OwnRoutes.propTypes = {
  t: PropTypes.func
};
export default OwnRoutes;
